import React from 'react';

// ─── Shimmer primitive ────────────────────────────────────────────────────────
const S = ({
    w = 'w-full',
    h = 'h-4',
    r = 'rounded-lg',
    cls = '',
}: {
    w?: string;
    h?: string;
    r?: string;
    cls?: string;
}) => (
    <div
        className={`${w} ${h} ${r} ${cls} flex-shrink-0`}
        style={{
            background: 'linear-gradient(90deg,var(--v2-border-subtle) 25%,var(--v2-border-card) 50%,var(--v2-border-subtle) 75%)',
            backgroundSize: '200% 100%',
            animation: 'skeletonShimmer 1.6s ease-in-out infinite',
        }}
    />
);
const OrderListSkeleton: React.FC = () => (
    <div className="flex flex-col gap-3 v2-animate-fade-in">

        <div className="flex items-center gap-2 flex-wrap">
            <S w="w-44" h="h-[36px]" r="rounded-xl" />
            <S w="w-44" h="h-[36px]" r="rounded-xl" />
            {/* Status FilterSelect */}
            <S w="w-36" h="h-[36px]" r="rounded-xl" />
            {/* Priority FilterSelect */}
            <S w="w-36" h="h-[36px]" r="rounded-xl" />
        </div>

        <div
            className="rounded-2xl border border-[var(--v2-border-card)] bg-[var(--v2-bg-card)] overflow-hidden"
            style={{ boxShadow: 'var(--v2-shadow-card)' }}
        >
            <div className="overflow-x-auto">
                <table className="w-full text-xs">

                    <thead>
                        <tr style={{ background: 'var(--v2-bg-surface)' }}>
                            <th className="px-3 py-2 text-left">
                                <S w="w-14" h="h-2.5" r="rounded-md" />
                            </th>
                            <th className="px-3 py-2 text-left">
                                <S w="w-10" h="h-2.5" r="rounded-md" />
                            </th>
                            <th className="px-3 py-2 text-left">
                                <S w="w-16" h="h-2.5" r="rounded-md" />
                            </th>
                            <th className="px-3 py-2 text-left">
                                <S w="w-20" h="h-2.5" r="rounded-md" />
                            </th>
                            <th className="px-3 py-2 text-left">
                                <S w="w-18" h="h-2.5" r="rounded-md" />
                            </th>
                            <th className="px-4 py-2 text-left">
                                <S w="w-12" h="h-2.5" r="rounded-md" />
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {Array.from({ length: 10 }).map((_, i) => (
                            <tr key={i} className="border-t border-[var(--v2-border-divider)]">

                                <td className="px-3 py-2">
                                    <div className="flex items-center gap-2">
                                        <S w="w-7" h="h-7" r="rounded-lg" />
                                        <div className="flex flex-col gap-1 min-w-0">
                                            <S w="w-[110px]" h="h-2.5" r="rounded-md" />
                                            <S w="w-[72px]" h="h-2" r="rounded-md" />
                                        </div>
                                    </div>
                                </td>

                                <td className="px-3 py-2">
                                    <div className="flex items-center gap-1">
                                        <S w="w-[130px]" h="h-[20px]" r="rounded-md" />
                                        <S w="w-[22px]" h="h-[20px]" r="rounded-md" />
                                    </div>
                                </td>

                                <td className="px-3 py-2">
                                    <S w="w-[80px]" h="h-2.5" r="rounded-md" />
                                </td>

                                <td className="px-3 py-2">
                                    <S w="w-[72px]" h="h-[20px]" r="rounded-full" />
                                </td>

                                <td className="px-3 py-2">
                                    <S w="w-[100px]" h="h-[20px]" r="rounded-full" />
                                </td>

                                <td className="px-4 py-3.5">
                                    <S w="w-8" h="h-8" r="rounded-lg" />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>

        <div className="flex items-center justify-between">
            <S w="w-28" h="h-[11px]" r="rounded-md" />
            <div className="flex gap-2">
                <S w="w-[64px]" h="h-[30px]" r="rounded-lg" />
                <S w="w-[64px]" h="h-[30px]" r="rounded-lg" />
            </div>
        </div>
    </div>
);

export default OrderListSkeleton;
